import { Card } from "components/atoms/Card"
import { ClientWebhook } from "components/molecules/ClientWebhook"
import { ClayWebhook } from "components/molecules/CrmContainer"

export const WebhooksModule = () => {
    return (
        <Card className="!p-0 h-fit overflow-hidden" headerClassName="p-4" icon="way" title="Send Leads via Webhook" subtitle="Set up integrations to receive revealed and deanonymized contact data instantly" bodyClassName="flex flex-col md:flex-row h-full w-full px-10 pb-10 gap-4 overflow-scroll">
            <div className="flex flex-col w-full border border-gray-700 p-8 rounded-xl gap-10">
                <ClayWebhook showSmall />
                <ClientWebhook showSmall />
            </div>
        </Card>
    )
}